import { Compass, Route, MapPin, ShieldCheck } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const BLOCKS = [
  {
    icon: Compass,
    title: "Personalised Guidance",
    desc: "Advice tailored to your goals, background, and budget — never one-size-fits-all.",
  },
  {
    icon: Route,
    title: "End-to-End Support",
    desc: "From course selection to visa grant, we walk beside you at every step.",
  },
  {
    icon: MapPin,
    title: "Melbourne-Based Local Experts",
    desc: "On-the-ground knowledge of Australian institutions, cities, and employers.",
  },
  {
    icon: ShieldCheck,
    title: "Transparent Process",
    desc: "Honest advice, clear fees, and no surprises — you always know what's next.",
  },
];

export default function WhyUs() {
  return (
    <section id="why-us" className="relative overflow-hidden bg-gradient-to-b from-sky-50 to-white py-24 sm:py-32">
      <span className="pointer-events-none absolute -right-10 top-8 select-none font-display text-[16rem] font-extrabold leading-none text-stroke-sky opacity-60 max-lg:hidden">
        02
      </span>
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <Chapter number="02" label="Why Choose Us" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 max-w-2xl font-display text-3xl font-extrabold tracking-[-0.03em] text-slate-900 sm:text-4xl lg:text-5xl">
            The Directive Pathway <span className="text-sky-600">Difference</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {BLOCKS.map((b, i) => (
            <Reveal key={b.title} delay={0.08 * i} className="h-full">
              <div
                data-testid={`why-us-block-${i + 1}`}
                className="group h-full rounded-2xl border border-sky-100 bg-white/80 p-7 backdrop-blur transition-all duration-500 hover:-translate-y-2 hover:border-sky-300 hover:shadow-[0_24px_60px_rgba(2,132,199,0.14)]"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sky-600 text-white shadow-[0_10px_24px_rgba(2,132,199,0.35)] transition-transform duration-500 group-hover:scale-110">
                  <b.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-6 font-display text-lg font-bold tracking-tight text-slate-900">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{b.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
